<template>
	<vue-progress-bar></vue-progress-bar>
	
	<AgreementComponent v-if="!loading && agreementLink != ''" :agreementLink="agreementLink"
		:agreementText="agreementText" :agreementButtonText="agreementButtonText" />

	<transition name="fade-loading-screen">
		<LoadingScreenComponent v-if="loading" :loading="loading" :failedLoading="failedLoading" />
	</transition>

	<transition name="fade-section">
		<DesignAachenComponent v-if="!loading && agreementLink == '' && mainSettings.theme == 'aachen'" 
			:sectionData="sectionData" :mainSettings="mainSettings" :debugData="debugData" :labelPreview="labelPreview" />

		<DesignTurinComponent v-else-if="!loading && agreementLink == '' && mainSettings.theme == 'turin'"
			:sectionData="sectionData" :mainSettings="mainSettings" :debugData="debugData" :labelPreview="labelPreview" />

		<DesignWienComponent v-else-if="!loading && agreementLink == '' && mainSettings.theme == 'wien'"
			:sectionData="sectionData" :mainSettings="mainSettings" :debugData="debugData" :labelPreview="labelPreview" />
	</transition>
</template>

<script>
import AgreementComponent from "./components/AgreementComponent.vue";
import LoadingScreenComponent from "./components/LoadingScreenComponent.vue";
import DesignAachenComponent from "./components/design-aachen/DesignAachenComponent.vue";
import DesignWienComponent from "./components/design-wien/DesignWienComponent.vue";
import DesignTurinComponent from "./components/design-turin/DesignTurinComponent.vue";


export default {
	name: 'App',
	components: {
		AgreementComponent,
		LoadingScreenComponent,
		DesignAachenComponent,
		DesignWienComponent,
		DesignTurinComponent
	},

	methods: {
		getHash() {
			// get the param hash
			let url = new URL(window.location.href);
			let hash = url.searchParams.get('hash');

			// Fallback hash (demo)
			if (hash !== null) {
				hash = hash.toString();
			}
			else {
				// TO BE REPLACED
				hash = 'ef01efc0b2428aa5b20c6c8c87f71bdf';
			}

			return hash;
		},

		getCustomer() {
			// get the param customer
			let url = new URL(window.location.href);
			let customer = url.searchParams.get('customer');

			// Fallback customer (demo)
			if (customer !== null) {
				customer = customer.toString();
			}
			else {
				customer = 'Test-Webexpose';
			}

			return customer;
		},

		debugging() {
			let url = new URL(window.location.href);
			let debug = url.searchParams.get('debug');

			if (debug === '1') {
				if (window.location.href.indexOf('?') > -1) {
					return '&debug=' + 1;
				}
				else {
					return '?debug=' + 1;
				}
			}
			else {
				return '';
			}
		},

		changeFavicon() {
			const favicon = document.querySelector('[rel=icon]');
			favicon.href = this.mainSettings.logo;
		},

		changeTitle() {
			var companyTitle;
			var objectTitle;

			if (this.mainSettings.footnote.firma) {
				companyTitle = this.mainSettings.footnote.firma.value;
			}

			for (let i = 0; i < this.sectionData.length; i++) {
				const element = this.sectionData[i];

				if (element.type == 'title') {
					objectTitle = element.config.objectTitle;
				}
			}

			if ((companyTitle == '' || companyTitle == undefined) && (objectTitle == '' || objectTitle == undefined)) {
				//do nothing
			}
			else if (companyTitle == '' || companyTitle == undefined) {
				document.title = objectTitle;
			}
			else if (objectTitle == '' || objectTitle == undefined) {
				document.title = companyTitle;
			}
			else {
				document.title = companyTitle + ' - ' + objectTitle;
			}

		},

		setColors() {
			document.documentElement.style.setProperty('--mainColor', this.mainSettings.mainColor);
			document.documentElement.style.setProperty('--mainColorBrighter', this.mainSettings.mainColor + '66');

			document.documentElement.style.setProperty('--secondaryColor', this.mainSettings.secondaryColor);
			document.documentElement.style.setProperty("--secondaryColorBrighter", this.mainSettings.secondaryColor + 'E6');

			document.documentElement.style.setProperty('--fontColor', this.mainSettings.fontColor);
		},

		setFontFamily() {
			document.documentElement.style.setProperty('--fontFamily', 'Montserrat, Times New Roman, serif');
		},

		setBodyClass() {

			if (this.mainSettings.theme == 'aachen') {
				document.body.classList.add('design-aachen');
			}
			else if (this.mainSettings.theme == 'turin') {
				document.body.classList.add('design-turin');
			}
			else if (this.mainSettings.theme == 'wien') {
				document.body.classList.add('design-wien');
			}
		}
	},

	data() {
		return {
			sectionData: [],
			mainSettings: [],
			agreementLink: [],
			agreementText: [],
			agreementButtonText: [],
			debugData: [],
			waterMark: [],
			labelPreview: [],
			loading: false,
			failedLoading: false
		};
	},

	mounted() {
		//JSON link with dynamic hash and cusomer params
		// let url = new URL(window.location.href);
		// 	let hash = url.searchParams.get('hash');
			
		var api = 'https://crm-beta.onoffice.de/smart/app/smart/webExpose/AppWebExposeData.php?hash=' + this.getHash() + '&customer=' + this.getCustomer() + this.debugging();

		this.$Progress.start();
		this.loading = true;

		fetch(api)
			.then(response => response.json())
			.then(data => {
				this.$Progress.set(38);

				if (Object.prototype.hasOwnProperty.call(data, "agreementLink")) {
					this.agreementLink = data.agreementLink;
					this.agreementText = data.agreementText;
					this.agreementButtonText = data.agreementButtonText;
				}
				else {
					this.webExposeData = data.webExposeData;
					this.sectionData = data.webExposeData.blocks;
					this.mainSettings = data.webExposeData.mainSettings;
					this.debugData = data.webExposeData.debugInfo;
					this.waterMark = data.webExposeData.useWaterMark;
					this.labelPreview = data.webExposeData.labelPreview;
				}

				this.getHash();
				this.getCustomer();
				this.setBodyClass();
				this.changeFavicon();
				this.changeTitle();
				this.setColors();
				// this.setFontFamily();
				this.$Progress.set(62);
				this.$Progress.finish();
				this.loading = false;
			}).catch(() => {
				this.loading = true;
				this.failedLoading = true;
				this.$Progress.finish();
			});
	},
}
</script>

<style lang="scss">
.fade-section-enter-active,
.fade-loading-screen-leave-active {
	transition: opacity 0.5s ease;
}

.fade-section-enter-from,
.fade-loading-screen-leave-to {
	opacity: 0;
}

.fade-section-enter-active {
	transition: opacity 0.5s ease;
	transition-delay: 1.5s;
}

.fade-section-enter-from {
	opacity: 0;
}
</style>